import React, { useState } from "react";
// import Navbar from '../navbar/Navbar';

import { Outlet } from "react-router-dom";
// import AdminHome from '../pages/AdminPannel/dashboard/Dashboard';
// import AdminHome from '../home/AdminHome';
import TopBar from "../navbar/TopNav";
import AccountNav from "../navbar/AccountNav";
import NavigationBar from "../navbar/Navbar";
import Footer from "../pages/Frontend/homePage/components/footer/Footer";
function MyAccountLayout() {
  return (
    <>
      <NavigationBar className="w-screen " />
      <div className="d-flex mt-[110px]  bg-white lg:w-11/12 md:w-11/12 w-full mx-auto">
        <AccountNav className="w-1/4" />
        <div
          className="w-full lg:w-3/4 min-h-[30vh] md:w-full p-3"
          style={{
            overflowY: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <Outlet />
        </div>
      </div>
      <Footer />
    </>
  );
}
export default MyAccountLayout;
